export default {
  InOrder: 1,
  TellYouLater: 2,
};
